import moment from 'moment-jalaali';
import { persianNumber } from './number';

function formatNumber(input) {
  const str = `${input}`;
  return str.length < 2 ? `0${str}` : str;
}

function formatDateShamsi(_dateShamsi, _format) {
  return _dateShamsi.format(_format);
}

function formatDateForApi(_date) {
  let month = `${_date.getMonth() + 1}`;
  let day = `${_date.getDate()}`;
  let year = _date.getFullYear();

  if (month.length < 2) {
    month = '0' + month;
  }

  if (day.length < 2) {
    day = '0' + day;
  }

  return [year, month, day].join('-');
}

function formatTime(_date, _format) {
  let output = `${_format}`;
  output = output.replace(/HH/g, formatNumber(_date.getHours()));
  output = output.replace(/H/g, _date.getHours());
  output = output.replace(/mm/g, formatNumber(_date.getMinutes()));
  output = output.replace(/m/g, _date.getMinutes());
  output = output.replace(/ss/g, formatNumber(_date.getSeconds()));
  output = output.replace(/s/g, _date.getSeconds());
  return output;
}

function formatDateTimeShamsi(_date, _dateShamsi, _format) {
  return formatTime(_date, formatDateShamsi(_dateShamsi, _format));
}

export default function date(input) {
  let _date = new Date();
  let _dateShamsi;
  let _timestamp;

  function isValid() {
    return !isNaN(_timestamp);
  }

  function format(_format) {
    return isValid ? persianNumber(formatDateTimeShamsi(_date, _dateShamsi, _format)) : '';
  }

  function formatForApi() {
    return isValid() ? `${formatDateForApi(_date)} ${formatTime(_date, 'HH:mm')}` : '';
  }

  function set(_t) {
    _timestamp = Date.parse(_t);

    if (isValid()) {
      _date.setTime(_timestamp);
      _dateShamsi = moment(_date);
    }
  }

  // Start with initial input
  set(input);

  return {
    // d: _date,
    format,
    formatForApi,
    isValid,
    set,
    toString: () => _date.format()
  };
}
